import { render } from "./ChangeOrderStatusForm.vue?vue&type=template&id=2160a175&scoped=true&ts=true&lang=pug"
import script from "./ChangeOrderStatusForm.vue?vue&type=script&lang=ts"
export * from "./ChangeOrderStatusForm.vue?vue&type=script&lang=ts"

import "./ChangeOrderStatusForm.vue?vue&type=style&index=0&id=2160a175&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2160a175"]])

export default __exports__